export default function Oracle() {
  return (
    <>
      <svg
        width="129"
        height="18"
        viewBox="0 0 129 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden md:block"
      >
        <title>Oracle</title>
        <path
          d="M55.69 11.178h8.524l-4.507-7.252-8.272 13.111H47.67L57.732 1.288a2.378 2.378 0 011.975-1.02c.782 0 1.511.37 1.936.994l10.101 15.775H67.98l-1.777-2.93h-8.63l-1.883-2.93zm39.108 2.93V.425h-3.195v15.02c0 .411.159.81.464 1.114.305.305.716.477 1.166.477h14.569l1.883-2.93H94.797zm-52.855-2.453c3.102 0 5.621-2.506 5.621-5.608a5.624 5.624 0 00-5.621-5.62H27.966v16.61h3.194V3.358h10.571a2.682 2.682 0 012.678 2.69A2.682 2.682 0 0141.73 8.74l-9.007-.013 9.537 8.312h4.64l-6.416-5.383h1.458zM8.307 17.037C3.72 17.037 0 13.325 0 8.74 0 4.152 3.721.427 8.307.427h9.655c4.586 0 8.305 3.725 8.305 8.312 0 4.586-3.719 8.298-8.305 8.298H8.307zm9.44-2.93a5.37 5.37 0 005.377-5.369 5.38 5.38 0 00-5.377-5.382H8.521A5.382 5.382 0 003.143 8.74a5.37 5.37 0 005.377 5.368h9.227zm60.665 2.93c-4.586 0-8.312-3.712-8.312-8.298 0-4.587 3.726-8.312 8.312-8.312H89.88l-1.87 2.93h-9.386a5.386 5.386 0 00-5.382 5.382c0 2.969 2.413 5.368 5.382 5.368h11.52l-1.882 2.93h-9.85zm39.068-2.93a5.368 5.368 0 01-5.17-3.91h13.654l1.883-2.93H112.31a5.384 5.384 0 015.17-3.91h9.373l1.895-2.93h-11.48c-4.587 0-8.312 3.724-8.312 8.311s3.725 8.299 8.312 8.299h9.85l1.882-2.93h-11.52z"
          fill="#9DA6C7"
        />
      </svg>

      <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="md:hidden"
      >
        <path
          d="M13.508 30.017A10.465 10.465 0 013 19.509C3 13.67 7.67 9 13.508 9h12.314C31.66 9 36.33 13.67 36.33 19.509c0 5.838-4.67 10.508-10.508 10.508H13.508zm11.995-3.715a6.772 6.772 0 006.793-6.793 6.772 6.772 0 00-6.793-6.794H13.827a6.772 6.772 0 00-6.793 6.794c0 3.715 3.078 6.793 6.793 6.793h11.676z"
          fill="#9DA6C7"
        />
      </svg>
    </>
  );
}
